<template>
  <div id="news-index">
    <header-section :subnav_show="false" :change_color="true"></header-section>

    <!-- 顶部Banner区 -->
    <div id="hero-news" data-aos="zoom-out" data-aos-delay="100">
      <div class="banner-content">
        <h1>新闻动态</h1>
        <p class="en-title">NEWS CENTER</p>
      </div>
    </div>

    <div class="container main-container">
      <!-- 页面标题 -->
      <div class="section-title">
        <h2>新闻动态</h2>
        <p>NEWS</p>
        <span class="title-line"></span>
      </div>

      <el-row :gutter="30">
        <!-- 左侧新闻列表 -->
        <el-col :span="18">
          <div class="news-list-card">
            <!-- 新闻列表 -->
            <ul v-if="reDataList.length > 0" class="news-list">
              <li v-for="(bean, index) in reDataList" :key="index" class="news-item">
                <a :href="'/news/detail/' + bean.id" target="_blank" class="item-link">
                  <!-- 左侧封面图 -->
                  <div class="item-img-box">
                    <img
                      v-if="typeof bean.image === 'undefined' || bean.image == null || bean.image === ''"
                      src="~@/static/img/news/default.jpg"
                      class="item-img"
                      alt="新闻封面"
                    />
                    <img v-else :src="bean.image" class="item-img" alt="新闻封面" />
                  </div>
                  <!-- 右侧文字信息 -->
                  <div class="item-text-box">
                    <h3 class="item-title">{{ bean.title }}</h3>
                    <div class="item-info-row">
                      <span class="item-date">
                        <i class="el-icon-time"></i> {{ formatDate(bean.createTime) }}
                      </span>
                    </div>
                    <div class="item-summary" v-html="bean.summary"></div>
                    <span class="item-more">
                      查看详情 <i class="el-icon-arrow-right"></i>
                    </span>
                  </div>
                </a>
              </li>
            </ul>

            <!-- 空数据提示 -->
            <div v-else class="empty-box">
              <i class="el-icon-document"></i>
              <p>暂无相关新闻数据</p>
            </div>

            <!-- 分页 -->
            <div class="pagination-box" v-if="reDataList.length > 0">
              <el-pagination
                @current-change="current_change"
                background
                layout="total, prev, pager, next, jumper"
                :total="total_data"
                :page-size="page_size"
                :current-page="current_page"
              >
              </el-pagination>
            </div>
          </div>
        </el-col>

        <!-- 右侧侧边栏 -->
        <el-col :span="6">
          <div class="sidebar-wrap">
            <!-- 新闻分类 -->
            <div class="sidebar-card">
              <div class="card-header">
                <i class="el-icon-folder-opened"></i> 新闻分类
              </div>
              <div class="card-body">
                <div
                  class="cate-item"
                  @click="queryParam.channelId=111;current_page = 1;getArticlePageList()"
                >
                  <a href="javascript:void(0)" :class="queryParam.channelId == 111 ? 'active' : ''">
                    全部分类
                  </a>
                </div>
                <div
                  v-for="(v, k) in reSubChannelList"
                  :key="k"
                  class="cate-item"
                  @click="queryParam.channelId=v.id;current_page = 1;getArticlePageList(v)"
                >
                  <a href="javascript:void(0)" :class="queryParam.channelId == v.id ? 'active' : ''">
                    {{ v.channelName }}
                  </a>
                </div>
              </div>
            </div>

            <!-- 热点新闻 -->
            <div class="sidebar-card">
              <div class="card-header">
                <i class="el-icon-star-on"></i> 热点新闻
              </div>
              <div class="card-body hot-list">
                <div v-for="(v, k) in reTopList" :key="k" class="hot-item" :title="v.title">
                  <router-link :to="'/news/detail/' + v.id">
                    <span class="hot-dot"></span>
                    {{ v.title }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <footer-section></footer-section>
  </div>
</template>

<script>
import store from '@/store'
import HeaderSection from "@/components/public/head.vue"
import FooterSection from "@/components/public/footer.vue"

export default {
  components: {
    HeaderSection,
    FooterSection
  },
  data() {
    return {
      queryParam: {
        channelId: 111,
        isShow: 1,
        page: 1,
        limit: 10
      },
      currChannelId: 111,
      current_page: 1,
      page_size: 10,
      total_pages: 0,
      total_data: 0,
      reSubChannelList: [],
      reDataList: [],
      reTopList: [],
    };
  },
  methods: {
    getArticlePageList(v) {
      if (v) {
        document.title = v.channelName + '-河北科瑞达仪器科技股份有限公司'
        let m = document.querySelectorAll('meta');
        const meta = document.createElement('meta')
        meta.name = 'keywords'
        meta.content = v.channelName
        m[0].after(meta)
        for(let i=0;i<m.length;i++){
          if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
            m[i].remove()
          }
        }
      }
      this.queryParam.page = this.current_page
      this.$get(this.$api.getArticlePageList, this.queryParam).then(response => {
        if (response.code === 0) {
          this.reDataList = response.data.list;
          this.page_size = response.data.pagesize;
          this.total_pages = response.data.totalpages;
          this.total_data = response.data.totalrecords;
          this.loading = false
        } else {
          window.console.log(response.msg);
        }
      });
    },
    getSubChannelList() {
      this.$get(this.$api.getSubChannelList + '/' + this.currChannelId).then(res => {
        if (res.code === 0) {
          this.reSubChannelList = res.data;
          this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    getArticleTopList() {
      this.$get(this.$api.getArticleTopList + '/' + this.currChannelId).then(res => {
        if (res.code === 0) {
          this.reTopList = res.data;
          this.loading = false
        } else {
          window.console.log(res.msg);
        }
      });
    },
    current_change(e) {
      this.current_page = e;
      this.getArticlePageList();
    },
    formatDate(value) {
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        const y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        return y + '-' + MM + '-' + d
      }
    },
    formatDateTime(value) {
      if (value == null) {
        return ''
      } else {
        const date = new Date(value)
        const y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? ('0' + MM) : MM
        let d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let h = date.getHours()
        h = h < 10 ? ('0' + h) : h
        let m = date.getMinutes()
        m = m < 10 ? ('0' + m) : m
        let s = date.getSeconds()
        s = s < 10 ? ('0' + s) : s
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
      }
    },
  },
  created() {
    if(store.state.tempid){
      this.queryParam.channelId = store.state.tempid
    }
    this.getSubChannelList();
    this.getArticlePageList();
    this.getArticleTopList();

    document.title='新闻动态-河北科瑞达仪器科技股份有限公司'
    let arr = ['首页','产品中心','解决方案','客户案例','新闻动态','人才招聘','关于我们','联系我们']
    let m = document.querySelectorAll('meta');
    const meta = document.createElement('meta')
    meta.name = 'keywords'
    for(let i=0;i<m.length;i++){
      arr.some(item => {
        if(item == m[i].content){
          m[i].remove()
        }
      })
    }
    meta.content = '新闻动态'
    m[0].after(meta)
    for(let i=0;i<m.length;i++){
      if(m[i].content =='河北科瑞达仪器科技股份有限公司'){
        m[i].remove()
      }
    }
  },
  beforeDestroy(){
    store.commit('set_temp_id', '')
  },
  mounted() {
    document.title='新闻动态-河北科瑞达仪器科技股份有限公司'
  }
};
</script>

<style scoped>
#news-index {
  overflow-x: hidden;
  background: #f5f7fa;
}

/* 顶部Banner */
#hero-news {
  width: 100%;
  height: 320px;
  background: url("~@/static/img/banner/news-banner.jpg") center center / cover no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
#hero-news::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(0, 30, 90, 0.6), rgba(0, 30, 90, 0.6));
}
.banner-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: #fff;
}
.banner-content h1 {
  font-size: 46px;
  font-weight: 600;
  margin: 0 0 10px;
  letter-spacing: 3px;
}
.banner-content .en-title {
  font-size: 16px;
  letter-spacing: 4px;
  opacity: 0.85;
  margin: 0;
}

/* 主容器 */
.main-container {
  padding: 60px 0 80px;
}
.section-title {
  text-align: center;
  margin-bottom: 50px;
}
.section-title h2 {
  font-size: 32px;
  color: #002b7a;
  font-weight: 600;
  margin: 0 0 6px;
}
.section-title p {
  color: #888;
  font-size: 14px;
  letter-spacing: 2px;
  margin: 0 0 12px;
}
.title-line {
  display: inline-block;
  width: 50px;
  height: 3px;
  background: #0047c8;
  border-radius: 2px;
}

/* 左侧新闻列表卡片 */
.news-list-card {
  background: #fff;
  border-radius: 12px;
  padding: 35px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}
.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.news-item {
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 1px solid #eef1f6;
  transition: all 0.3s ease;
}
.news-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.item-link {
  display: flex;
  gap: 24px;
  text-decoration: none;
  color: inherit;
}
.item-img-box {
  width: 260px;
  height: 165px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
}
.item-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s ease;
}
.news-item:hover .item-img {
  transform: scale(1.08);
}
.item-text-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-title {
  font-size: 20px;
  color: #222;
  margin: 0 0 12px;
  font-weight: 500;
  line-height: 1.4;
  transition: color 0.3s ease;
}
.news-item:hover .item-title {
  color: #0047c8;
}
.item-info-row {
  margin-bottom: 12px;
}
.item-date {
  font-size: 13px;
  color: #999;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.item-summary {
  color: #666;
  font-size: 14px;
  line-height: 1.75;
  margin-bottom: 14px;
}
.item-summary /deep/ p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin: 0;
}
.item-more {
  font-size: 14px;
  color: #0047c8;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: gap 0.3s ease;
}
.news-item:hover .item-more {
  gap: 10px;
}

/* 空状态 */
.empty-box {
  text-align: center;
  padding: 80px 0;
  color: #aaa;
}
.empty-box i {
  font-size: 56px;
  margin-bottom: 16px;
  color: #d7dde8;
}
.empty-box p {
  font-size: 15px;
  margin: 0;
}

/* 分页 */
.pagination-box {
  margin-top: 40px;
  text-align: center;
}
/deep/ .el-pagination__jump {
  margin-left: 12px;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0047c8;
}

/* 右侧侧边栏 */
.sidebar-wrap {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.sidebar-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}
.card-header {
  height: 52px;
  line-height: 52px;
  padding: 0 22px;
  background: #0047c8;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
}
.card-body {
  padding: 10px 22px 20px;
}
.cate-item {
  line-height: 44px;
  border-bottom: 1px solid #f0f2f7;
  cursor: pointer;
}
.cate-item:last-child {
  border-bottom: none;
}
.cate-item a {
  display: block;
  padding: 0 10px;
  color: #444;
  font-size: 15px;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.cate-item a.active {
  background: #0047c8;
  color: #fff;
}
.cate-item:hover a:not(.active) {
  color: #0047c8;
  background: #f0f5ff;
}

/* 热点新闻 */
.hot-list {
  padding: 16px 22px 20px;
}
.hot-item {
  line-height: 38px;
  border-bottom: 1px dashed #eee;
  overflow: hidden;
}
.hot-item:last-child {
  border-bottom: none;
}
.hot-item a {
  font-size: 14px;
  color: #555;
  text-decoration: none;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  transition: color 0.3s ease;
}
.hot-item a:hover {
  color: #0047c8;
}
.hot-dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0047c8;
  margin-right: 8px;
  vertical-align: middle;
}
</style>